<sl-title title="Approval Setup"></sl-title>

<mat-tab-group dynamicHeight class="linq-tab-bar" #tabs>
	<mat-tab label="PO Approval Levels">
		<ss-approval-level #poapproval [approvalType]="poApprovalType"></ss-approval-level>
	</mat-tab>
	<mat-tab label="Invoice Approval Levels">
		<ss-approval-level #invoiceapproval [approvalType]="invoiceApprovalType"></ss-approval-level>
	</mat-tab>
</mat-tab-group>
